import {DELETE_EVENTS_ERROR, DELETE_EVENTS_START, DELETE_EVENTS_SUCCESS} from "../../types";

export default function delete_events(state, action) {
    switch (action.type) {
        case DELETE_EVENTS_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DELETE_EVENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case DELETE_EVENTS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
